/**
 * Component to display Excel files preview by using x-data-spreadsheet
 */
//  Third party packages imports
import * as XLSX from 'xlsx/xlsx.mjs';
import Spreadsheet from "x-data-spreadsheet";
import "x-data-spreadsheet/dist/xspreadsheet.css";

//  Generic imports
import React, { createRef, useEffect, useMemo, forwardRef, useImperativeHandle } from 'react';

//  Internal imports
import "./XLViewer.scss";
import Utils from '../../utils/Utils';

const XLViewer = forwardRef((props, ref) => {
  const spreadSheetRef = createRef();
  const [workbook, setWorkbook] = React.useState(XLSX.utils.book_new());
  const utils = new Utils();

  //  Options for Spreadsheet
  const options = useMemo(() => ({
    mode: 'read',
    showToolbar: false,
    showGrid: true,
    showContextmenu: false,
    view: {
      height: () => document.documentElement.clientHeight - 50,
      width: () => document.documentElement.clientWidth - 50,
    },
    row: {
      len: 100,
      height: 25,
    },
    col: {
      len: 26,
      width: 100,
      indexWidth: 60,
      minWidth: 60,
    },
    style: {
      bgcolor: '#ffffff',
      align: 'left',
      valign: 'middle',
      textwrap: false,
      strike: false,
      underline: false,
      color: '#0a0a0a',
      font: {
        name: 'EYInterstate',
        size: 10,
        bold: false,
        italic: false,
      },
    },
  }), []);

  /**
   * Hook to Initialize Spreadsheet with options
   */
  useEffect(() => {
    if (spreadSheetRef.current && !spreadSheetRef.current.grid) {
      spreadSheetRef.current.grid = new Spreadsheet(spreadSheetRef.current, options);
    }
  }, [spreadSheetRef, options]);

  /**
   * Read the excel file through XLSX and set to workbook
   */
  useEffect(() => {
    if (props.document) {
      const workbook = XLSX.read(props.document);
      setWorkbook(workbook);
    }
  }, [props.document]);

  /**
   * Convert the workbook data to Spreadsheet compatible data and load it to Spreadsheet
   */
  useEffect(() => {
    if (workbook?.SheetNames?.length > 0) {
      try {
        const vSTOX = utils.stox(workbook);
        const vSpreadSheet = spreadSheetRef.current?.grid;
        vSpreadSheet.loadData(vSTOX);
      } catch (error) {
        //  error
        console.error("Error loading spreadsheet data:", error);
      }
    }
  }, [workbook, props.document]);

  /**
   * call navigation to sheet from parent component
   */
  useImperativeHandle(ref, () => ({
    gotoSheet(vSheetName) {
      try {
        const vSpreadsheet = spreadSheetRef.current?.grid;
        const vSheetBar = vSpreadsheet.bottombar;
        const vSheetIndex = vSheetBar.dataNames.findIndex((element => (element === vSheetName)));
        if (vSheetIndex !== -1) {
          const vItem = vSheetBar.items[vSheetIndex];
          vSheetBar.clickSwap2(vItem);
        }
      } catch (error) {
        //  error
      }
    }
  }));

  return (
    <div id="idSpreadsheet" ref={spreadSheetRef}></div>
  );
});

export default XLViewer;